import { actionCreators } from '../../store/actions';
import ReduxActions from '../../store/ReduxActions';
import BackendApiClient from './BackendApiClient';
import { DataWrappedResponse } from '../exports/Types';
import {
  CashbackAccount,
  CashbackAccountStats,
  CashbackHistoryOperation,
  CashbackUpcomingExpiration,
  PaginatedResponse,
  ProfileInterface,
} from '../exports/Interfaces';
import { Response } from '../exports/Types';
import { profileOrderFields } from '../helpers/ProfileOrderFields';

class ProfileManager {
  public getProfile = async (companyId: number): Promise<DataWrappedResponse<ProfileInterface>> => {
    const request = await BackendApiClient.request({
      method: 'GET',
      url: `/companies/${companyId}/profile`,
    });
    const { response, success } = request;

    if (success) {
      ReduxActions.dispatch(this.profileAction(response?.data?.data));
    }

    return request;
  };

  public putProfile = async (
    companyId: number,
    data: ProfileInterface,
  ): Promise<DataWrappedResponse<ProfileInterface>> => {
    const request = await BackendApiClient.request({
      method: 'PUT',
      url: `/companies/${companyId}/profile`,
      data,
    });
    const { response, success } = request;

    if (success) {
      ReduxActions.batchActions([this.profileAction(response.data.data), this.orderAction(response.data.data)]);
    }

    return request;
  };

  public getCashbackAccount = async (companyId: number): Promise<DataWrappedResponse<CashbackAccount>> => {
    const request = await BackendApiClient.request({
      method: 'GET',
      url: `/companies/${companyId}/cashback-account`,
    });
    const { response, success } = request;

    if (success) {
      ReduxActions.dispatch(actionCreators.initialData.setCashbackAccount(response.data.data));
    }

    return request;
  };

  public getCashbackUpcomingExpiration = async (
    companyId: number,
  ): Promise<DataWrappedResponse<CashbackUpcomingExpiration | null>> =>
    BackendApiClient.request({
      method: 'GET',
      url: `/companies/${companyId}/cashback-account/upcoming-expiration`,
    });

  public getCashbackOperations = async (
    companyId: number,
    params: { page?: number; page_size?: number } = {},
  ): Promise<Response<PaginatedResponse<CashbackHistoryOperation>>> =>
    BackendApiClient.request({
      method: 'GET',
      url: `/companies/${companyId}/cashback-account/operations`,
      params,
    });

  public getCashbackOperationsStats = async (companyId: number): Promise<DataWrappedResponse<CashbackAccountStats>> =>
    BackendApiClient.request({
      method: 'GET',
      url: `/companies/${companyId}/cashback-account/operations/stats`,
    });

  private profileAction(data: ProfileInterface) {
    return actionCreators.profile.setProfile(data);
  }

  private orderAction(data: ProfileInterface) {
    return actionCreators.order.updateOrder(profileOrderFields(data));
  }
}

export default new ProfileManager();
